/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import Accesspage from './../../common/404';
import Counsellor_Profile from '../Counselling/profile';
import Manager_Dashboard from '../Dashboard';
import Add_User from './../../modules/settings/User/Add-User';
import Add_Role from './../../modules/settings/Role/Add-Role';
import Role_List from './../../modules/settings/Role/Role-List';
import Idle_TAT_Report from '../Reports/Idle-TAT-Report';
import TAT_Report from '../Reports/Tat-Report';
import User_List from './../../modules/settings/User/User-List';
import Privilege_Create from './../../modules/settings/Privilege/Privilege-Create';
import User_Doctor_Map from './../../modules/settings/User/User-to-Doctor-Map';
import User_Details from './../../modules/settings/User/User-Details';
import Track_Bills from './../../modules/Track-Bills';
import Due_worklist from './../Reports/Due-worklist';
import Planned_Admission from './../Planned_Admission/index';
import PerAuthWorklist from './../Pre-auth_worklist/index';
import Surgeries from './../Surgeries/index';
import Interim_Enhacement from './../Interim-Enhacement/index'
import Pending_docs from './../Counselling/Patient/pending-docs';
// import Consent_Patients_List from './../consent-patients-list';
import Estmate_variance_Worklist from './../Estimate-Variance/index';
import Consent_Patients_List from './../Counselling/Patient/consent-patients-list';
import DiscountRequest from '../Discount-Request';
import CounsellingPending from '../Counselling-Pending';
import InsuranceExecutive from '../Insurance_Executive_Worklist';
import { userList } from '../../schema/user';
import AdmissionsAdvised from '../Admissions-Advised';
import PostAuthWorklist from '../Post-auth_worklist';
import GREWorklist from '../GRE';
import DMOWorklist from '../DMO';
import PerAuthWorklistNew from '../Pre-auth_worklist/indexnew';
import PerAuthDMOPendingWorklist from '../Pre-auth_worklist/pendingDMO';
import TagVip from '../Tag-Vip';
class Worklist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            "showAdd": false,
            "showEdit": false,
            "showView": false,
        };
    }
    componentDidMount() {
        // this.renderPermission();
    }
    renderbodyLayer() {
        const { id, slug } = this.props.match.params
        const { menuList } = this.props;
        let showAdd = false;
        let showEdit = false;
        let showView = false;
        // let obj = null;
        // menuList.map(data => {
        //     var subData = data
        //         .submenu
        //         .find(o => o.route === slug);
        //     console.log(subData);
        //     if (subData != undefined) {
        //         obj = subData;
        //     }
        // })


        menuList.map((menu) => {
            console.log('MENU:::', menu);
            if (slug !== undefined && slug !== null && slug !== '') {

                if (menu['route'] === id) {
                    menu['submenu'].map((smenu) => {
                        if (slug === 'add-user' || slug === 'edit-user' || slug === 'view-user') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'users') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }
                        if (slug === 'add-counselling-stations' || slug === 'edit-counselling-stations' || slug === 'view-counselling-stations') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'counselling-stations') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }
                        if (slug === 'add-doctor' ||slug === 'edit-doctor' || slug === 'view-doctor') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'doctors') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }

                        if (slug === 'add-role' ||slug === 'edit-role' || slug === 'view-role') {
                            menu['submenu'].map((srmenu) => {
                                if (srmenu['route'] === 'roles') {
                                    showView = JSON.parse(srmenu['permissions']['view']);
                                    showAdd = JSON.parse(srmenu['permissions']['add']);
                                    showEdit = JSON.parse(srmenu['permissions']['edit']);
                                }
                            });
                        }

                        if (smenu['route'] === slug) {
                            showView = JSON.parse(smenu['permissions']['view']);
                            showAdd = JSON.parse(smenu['permissions']['add']);
                            showEdit = JSON.parse(smenu['permissions']['edit']);
                        }
                    })
                }
            }

            if (slug === undefined && id !== undefined) {
                if (menu['route'] === id) {
                    showView = JSON.parse(menu['permissions']['view']);
                    showAdd = JSON.parse(menu['permissions']['add']);
                    showEdit = JSON.parse(menu['permissions']['edit']);
                }
            }
        })
       


        var page = null;
        // if (obj !== undefined) {
            console.log('MENUMENU:::', slug)
            switch (slug) {
                case 'track-bills':
                        page = <Track_Bills {...this.props} menuList={menuList} />;
                    break;
                case 'due-worklist':
                     page = <Due_worklist {...this.props} menuList={menuList} />;
                     break;
                case 'planned-admissions':
                     page = <Planned_Admission {...this.props} menuList={menuList} />;
                    break;     
                case 'pre-auth-worklist':
                    // page=<PerAuthWorklist {...this.props} menuList={menuList}/>;
                    page=<PerAuthWorklistNew {...this.props} menuList={menuList}/>;
                    break;
                case 'surgeries-worklist':
                    page=<Surgeries {...this.props} menuList={menuList}/>;
                    break;
                case 'interim-enhancements':
                    page = <Interim_Enhacement {...this.props} {...this.state} menuList={menuList} />;
                    break; 
                case 'pending-docs':
                    page = <Pending_docs {...this.props} menuList={menuList} />;
                    break;
                case 'consent-patients':
                    page = <Consent_Patients_List {...this.props} menuList={menuList} />;
                    break;
                case 'estimate-variance':
                    page = <Estmate_variance_Worklist {...this.props} menuList={menuList} />;
                    break;
                case 'admissions-advised':
                    page = <AdmissionsAdvised {...this.props} menuList={menuList} />;
                    break;
                case 'discount-requests':
                    page = <DiscountRequest {...this.props} menuList={menuList} />;
                    break;
                case 'counselling-pending':
                    page = <CounsellingPending {...this.props} menuList={menuList} />;
                    break;
                case 'query-worklist':
                    page = <InsuranceExecutive {...this.props} menuList={menuList} />;
                    break;
                case 'post-auth-worklist':
                    page=<PostAuthWorklist {...this.props} menuList={menuList}/>;
                    break;  
                case 'gre-worklist':
                    page=<GREWorklist {...this.props} menuList={menuList}/>;
                    break;
                case 'dmo-worklist':
                    page=<DMOWorklist {...this.props} menuList={menuList}/>;
                    break;   
                case 'dmo-pending-worklist':
                    page=<PerAuthDMOPendingWorklist {...this.props} menuList={menuList}/>;
                    break;
                case 'tag-untag-vip':
                    page=<TagVip {...this.props} menuList={menuList}/>;
                    break;                 
                default:
                    let submenu = null;
                    page = <Accesspage></Accesspage>;
                   
                    break;
            }
        return page;
    }
    render() {

        return (
            <div>
                {this.renderbodyLayer()}
            </div>
        );
    }
}

export default Worklist;
